import React, {useCallback, useEffect, useMemo, useState} from 'react';
import {
    areAnyLoading,
    finishAlertSnippetClose,
    getQueryString,
    getReturnUrl,
    readCartSnippetParams,
    readShowDeclineButton
} from "../../Helpers/Globals";
import useServiceUrls from "../../Utils/UseServiceUrls";
import useAlert from "../../Utils/UseAlert";
import useAlertResponse, {ALERT_RESPONSE} from "../../Utils/UseAlertResponse";
import LoadingSpinner from "../LoadingSpinner";
import Header from "../Header";
import AlertMessage from "./AlertMessage";
import AlertResponseButtons from "./AlertResponseButtons";

const readAlertUid = (href = window.location.href) =>
    getQueryString(href, 'bl_alertUid') ?? getQueryString(href, 'alertUid') ?? ''

export default function AlertSnippet(props) {
    const initialParams = useMemo(() => readCartSnippetParams(), [])
    const [sessionKey, setSessionKey] = useState(initialParams.sessionKey)
    const [domain, setDomain] = useState(initialParams.loginDomain)
    const [cartUid, setCartUid] = useState(initialParams.cartUid)
    const [cartExternalId, setCartExternalId] = useState(initialParams.cartExternalId)
    const [cartSourceExternalId, setCartSourceExternalId] = useState(initialParams.cartSourceExternalId)
    const [returnUrl, setReturnUrl] = useState(initialParams.returnUrl)
    const [alertUid, setAlertUid] = useState(() => readAlertUid())
    const [showDeclineButton, setShowDeclineButton] = useState(() => readShowDeclineButton())
    const { serviceUrlsStatus, serviceUrls, serviceUrlsError } = useServiceUrls(domain);
    const { status: alertStatus, alert, error: alertError } = useAlert(serviceUrls, sessionKey, alertUid);

    // The alert is not acknowledged on load any more: every button sends its response, and closing
    // the window without choosing records Dismissed.
    const { respond } = useAlertResponse({serviceUrls, sessionKey, cartUid, cartExternalId, cartSourceExternalId, alertUid})

    useEffect(() => {
        const params = readCartSnippetParams()
        setSessionKey(params.sessionKey)
        setDomain(params.loginDomain)
        setCartUid(params.cartUid)
        setCartExternalId(params.cartExternalId)
        setCartSourceExternalId(params.cartSourceExternalId)
        setReturnUrl(params.returnUrl)
        setAlertUid(readAlertUid())
        setShowDeclineButton(readShowDeclineButton())
    }, [window.location.search]);

    const handleClose = useCallback((response) => {
        respond(response)
        finishAlertSnippetClose({
            returnUrl: returnUrl || getReturnUrl(window.location.href),
        })
    }, [respond, returnUrl])

    const handleDeclined = useCallback(() => handleClose(ALERT_RESPONSE.Declined), [handleClose])
    const handleDismissed = useCallback(() => handleClose(ALERT_RESPONSE.Dismissed), [handleClose])

    const isLoading = areAnyLoading([alertStatus, serviceUrlsStatus])

    return (
        <>
            <Header title={'Alert'}/>
            {isLoading ? <LoadingSpinner /> : null}
            {!isLoading &&
                <div className={'container'}>
                    <div className={'snippetContainer center'}>
                        {alert ? <AlertMessage message={alert.Message} /> : <p>Unable to find alert</p>}
                        <AlertResponseButtons showDeclineButton={showDeclineButton} onDeclined={handleDeclined} onDismissed={handleDismissed}/>
                    </div>
                </div>
            }
            {alertError ? <p className='error-text'>{alertError}</p> : null}
            {serviceUrlsError ? <p className='error-text'>{serviceUrlsError}</p> : null}
        </>
    )
}
